import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-standard-page-layout',
  imports: [],
  templateUrl: './standard-page-layout.component.html',
  styleUrl: './standard-page-layout.component.scss',
})
export class StandardPageLayoutComponent {
  @Input() title?: string;
  @Input() subtitle?: string;
}
